import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  selector: 'formly-field-textarea',
  template: `
    <textarea
      [name]="key"
      [cols]="props.cols"
      [rows]="props.rows"
      class="form-control"
      [class.is-invalid]="showError"
      [formlyAttributes]="field"
      [disabled]="props.disabled"
    ></textarea>
  `,
})
export class FormlyFieldTextarea extends FieldType {
  get type() {
    return this.props.type || 'text';
  }
}
